/**
 * ClaimConflictToast — typed copy wrapper around the lib/toast helper.
 *
 * Plan 02-09 / D-16 / CHORE-06.  The mutation hook (`useChoreActions.claim`)
 * fires this as a "warn" toast with the Norwegian copy:
 *   "{{winner}} var raskere — prøv en annen!"
 *
 * The wrapper exists so that future surfaces (e.g. Storybook, Plan 17
 * visual regression) can compose the toast with a stable text contract
 * without re-deriving the i18n key. Since issue #56 the mutation hook's 409
 * branch routes through here rather than calling `toast(...)` itself, so the
 * toast <ToastViewport/> renders carries the `claim-conflict-toast` testid —
 * one place owns both the copy and the test handle.
 *
 * NOTE: the i18n key + React text node guarantees XSS-safe rendering
 * (T-02-30) — react escapes by default; never use dangerouslySetInnerHTML.
 */
import type { TFunction } from 'i18next';
import { toast } from '../../lib/toast';

interface FireOpts {
  /** Translator (from useTranslation()) — passed in to keep this fn pure. */
  t: TFunction;
  /** Claimer's short_name from the 409 response body's `current` row. */
  winner: string;
}

/** Fire the warm Norwegian "X was faster" toast. */
export function fireClaimConflictToast({ t, winner }: FireOpts): void {
  toast({
    kind: 'warn',
    body: t('chores.claim.conflict', { winner }),
    testId: 'claim-conflict-toast',
  });
}
